// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".name-list-block[data-v-208ed72a]{font-family:\"Brown\",serif}", ""]);
// Exports
module.exports = exports;
